import { render, staticRenderFns } from "./LeisuresModule.vue?vue&type=template&id=41de50ef&scoped=true"
import script from "./LeisuresModule.vue?vue&type=script&lang=js"
export * from "./LeisuresModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de50ef",
  null
  
)

export default component.exports